import { authRoles } from 'app/auth';
import VizsgaEditForm from './editform/VizsgaEditForm';
import VizsgaTable from './table/VizsgaTable';

export default [
	{
		path: '/vizsga/edit/:id',
		component: VizsgaEditForm,
		auth: authRoles.admin
	},
	{
		path: '/vizsga/:sessionNameParam?',
		component: VizsgaTable,
		auth: authRoles.admin
	}
];
